export type FontSizePreference = "small" | "medium" | "large";

const STORAGE_KEY = "monstera_pwa_font_size";

export function getFontSizePreference(): FontSizePreference {
  const value = localStorage.getItem(STORAGE_KEY);
  return value === "small" || value === "large" ? value : "medium";
}

export function applyFontSizePreference(value: FontSizePreference) {
  document.documentElement.dataset.fontSize = value;
  localStorage.setItem(STORAGE_KEY, value);
}

export function restoreFontSizePreference() {
  document.documentElement.dataset.fontSize = getFontSizePreference();
}
